module.exports = __webpack_public_path__ + "static/stethoscope-85f7a8bee3e24b88cc39ad78ddd11786.png";